// extracted by mini-css-extract-plugin
module.exports = {"mdxBigQuote":"mdx-big-quote-module--mdx-big-quote--1Mayf"};